import { Offcanvas } from "react-bootstrap";
import { CheckCircle, XCircle } from "lucide-react";
import styles from "./EntityDetailsSidebar.module.scss";

/**
 * Panel lateral genérico para mostrar detalles de una entidad.
 * @param {Object} props
 * @param {boolean} props.isVisible - Controla si se muestra el panel.
 * @param {Function} props.onClose - Función para cerrar el panel.
 * @param {string} props.title - Título del panel.
 * @param {JSX.Element} props.icon - Ícono opcional a mostrar junto al título.
 * @param {Object} props.data - Objeto con los datos de la entidad.
 * @param {Array} props.schema - Lista de campos a mostrar [{ label, key, render }]
 */
const EntityDetailsSidebar = ({
  isVisible,
  onClose,
  title,
  icon,
  data,
  schema,
}) => {
  if (!data) return null;

  return (
    <Offcanvas
      show={isVisible}
      onHide={onClose}
      placement="end"
      className={styles.novianSidebar}
    >
      <Offcanvas.Header closeButton>
        <div className={styles.sidebarHeader}>
          <span className="text-dark">{icon}</span>
          <span className="text-dark">{title}</span>
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className={styles.sidebarSection}>
          <h5 className={styles.userName}>{data.fullName || data.name}</h5>
          {data.email && <p className={styles.userEmail}>{data.email}</p>}
          {"isActive" in data && (
            <span
              className={`${styles.badge} ${
                data.isActive ? styles.badgeSuccess : styles.badgeDanger
              }`}
            >
              {data.isActive ? (
                <>
                  <CheckCircle size={14} className="me-1" /> Activo
                </>
              ) : (
                <>
                  <XCircle size={14} className="me-1" /> Inactivo
                </>
              )}
            </span>
          )}
        </div>

        <div className={styles.sidebarInfo}>
          {schema.map((field, index) => (
            <div className={styles.infoRow} key={index}>
              <strong>{field.label}:</strong>
              <span>
                {field.render
                  ? field.render(data[field.key], data)
                  : data[field.key] || "—"}
              </span>
            </div>
          ))}
        </div>

        <div className={`mt-4 text-end ${styles.sidebarFooter}`}>
          <button className="btn btn-primary" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default EntityDetailsSidebar;
